import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b40667d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = {
  ref: "textDiv",
  class: "textDiv"
}
const _hoisted_3 = {
  ref: "mypageNameHeader",
  class: "name-label"
}
const _hoisted_4 = { class: "user-name" }
const _hoisted_5 = { class: "bold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("님 ")
const _hoisted_7 = {
  src: "/assets/icon/angel.png",
  srcset: "/assets/icon/angel@2x.png 2x,/assets/icon/angel@3x.png 3x"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/settings.png",
    srcset: "/assets/icon/settings@2x.png 2x,/assets/icon/settings@3x.png 3x"
  })
], -1))
const _hoisted_9 = { class: "container_wrap" }
const _hoisted_10 = { class: "main-container" }
const _hoisted_11 = { class: "main_padding" }
const _hoisted_12 = { class: "main-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 스톡옵션 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "상세보기", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_16 = { class: "wbox-radius" }
const _hoisted_17 = { class: "wbox-content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comb-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "보유현황")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "스톡옵션 세금계산기 > ", -1))
const _hoisted_20 = { class: "deal-info" }
const _hoisted_21 = { class: "c_logo" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_24 = { class: "overflow" }
const _hoisted_25 = { class: "deal-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        fullscreen: true,
        "scroll-events": true,
        onIonScroll: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleScroll($event.target)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doRefresh($event)))
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, null, 512),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user.name), 1),
                _hoisted_6,
                _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                  [_vShow, _ctx.isLead]
                ])
              ]),
              _createVNode(_component_router_link, {
                class: "ion-activatable ripple-parent",
                to: "/settings",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'설정버튼영역', 'clickContent':'설정버튼클릭'});})
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _: 1
              })
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_router_link, { to: {name:'StockOption'} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent right",
                        onClick: _cache[2] || (_cache[2] = () => {
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'상세보기'})
                    _ctx.router.push({name:'StockOption'})
                  })
                      }, [
                        _hoisted_14,
                        _hoisted_15,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent stock-info",
                      onClick: _cache[3] || (_cache[3] = () => {
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'스톡옵션세금계산기'})
                    _ctx.router.push({name:'StockOption', params : {scroll: 'calc'}})
                  })
                    }, [
                      _hoisted_19,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockOption, (stock) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: stock.stockOptionId,
                        class: "comb-content",
                        onClick: _cache[4] || (_cache[4] = () => {
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'목록'})
                    _ctx.router.push({name:'StockOption'})
                  })
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("img", {
                              src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                              onerror: "this.src='/assets/icon/company_default_img.png'",
                              class: "img-circle img-responsive"
                            }, null, 8, _hoisted_22),
                            _hoisted_23
                          ]),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(stock.companyName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$filters.currency(stock.asset)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}